/*
 * @Author: Ryan
 * @Date: 2025-12-02
 * @Description: Trust section component with statistics and company logos
 */
import Image from 'next/image';
import React from 'react';

interface StatCardProps {
  number: string;
  descriptionKey: string;
}

const StatCard: React.FC<StatCardProps> = ({ number, descriptionKey }) => {
  return (
    <div className="bg-[#1F1F1F] rounded-2xl py-[20px] flex flex-col justify-center items-center text-center">
      <div className="text-3xl pad:text-4xl sm:text-5xl font-bold text-white mb-2">
        {number}
      </div>
      <div className="text-xs pad:text-sm sm:text-base text-gray-300">
        {descriptionKey}
      </div>
    </div>
  );
};

const TrustSection: React.FC = () => {
  const stats = [
    {
      number: '54,113,192',
      descriptionKey: 'Videos generated',
    },
    {
      number: '48,641,186',
      descriptionKey: 'Avatars generated',
    },
    {
      number: '11,895,246',
      descriptionKey: 'Videos translated',
    },
  ];

  return (
    <section className="w-full bg-[#F2F2F2] py-[90px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto">
        {/* Statistics Cards */}
        <div className="grid grid-cols-1 pad:grid-cols-3 gap-3 pad:gap-6">
          {stats.map((stat, index) => (
            <StatCard
              key={index}
              number={stat.number}
              descriptionKey={stat.descriptionKey}
            />
          ))}
        </div>

        {/* Company Logos */}
        <Image
          src="/images/landing-company-logo.png"
          alt="Trusted companies"
          width={1190}
          height={68}
          className="w-full h-auto my-[10px]"
        />

        <div className="flex items-center">
          <p className="text-sm text-gray-600">
            Trusted by millions worldwide to bring their stories to life.
          </p>
          <div className="h-[1px] flex-1 bg-[#D1D5DC]"></div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
